import { Alarm, AlarmResponse, AlarmValue } from "../alarm/alarm.model";
import {
  ConversionTable,
  ConversionTableResponse,
} from "../conversion-table/conversion-table.model";
import {
  Point,
  PointResponse,
  PointType,
  PointValue,
  PuckValue,
} from "./point.model";

type PointTypeFactoryResponse =
  | PointResponse
  | AlarmResponse
  | ConversionTableResponse;

export class PointTypeFactory {
  static create(data: PointTypeFactoryResponse) {
    switch (data.type) {
      case PointType.Alarm:
        return new Alarm(data as AlarmResponse);
      case PointType.ConversionTable:
        return new ConversionTable(data as ConversionTableResponse);
      default:
        return new Point(data);
    }
  }

  static value({
    value,
    pointType,
  }: {
    value?: PuckValue;
    pointType: PointType;
  }) {
    if (!value) {
      return undefined;
    }
    switch (pointType) {
      case PointType.Alarm:
        return new AlarmValue(value);
      default:
        return new PointValue(value);
    }
  }
}
